module.exports = __webpack_public_path__ + "img/MTABAPPPROTOCOL.46477ab3.jpg";